'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function ScrollToTop() {
  const pathname = usePathname();

  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname is the trigger, not a value used inside the effect
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
